import { convertToISODuration } from './durationUtils';
/** Missing buffer side uses 0 minutes (Moment serializes this as e.g. `P0D`). */
var defaultMissingBufferIso = function () {
    return convertToISODuration('0', 'minutes');
};
/**
 * Builds the form `spaceBuffers` map from API event spaces (EDIT mode).
 * Returns `undefined` when there are no spaces or none define `desired_buffers`.
 *
 * When a space has at least one buffer duration from the API, any missing
 * before/after duration is initialized to **0 minutes** (ISO via `convertToISODuration`).
 */
export var getSpaceBuffersFromSpaces = function (spaces) {
    if (!spaces) {
        return undefined;
    }
    var hasBuffers = false;
    var result = spaces.reduce(function (acc, space) {
        var _a, _b;
        if (!((_a = space.desired_buffers) === null || _a === void 0 ? void 0 : _a.before_duration) &&
            !((_b = space.desired_buffers) === null || _b === void 0 ? void 0 : _b.after_duration)) {
            return acc;
        }
        hasBuffers = true;
        var _c = space.desired_buffers, beforeDuration = _c.before_duration, afterDuration = _c.after_duration, bufferBeforeId = _c.buffer_before_id, bufferAfterId = _c.buffer_after_id;
        var hasAtLeastOneBuffer = !!beforeDuration || !!afterDuration;
        var defaultWhenBuffersEnabled = hasAtLeastOneBuffer
            ? defaultMissingBufferIso()
            : undefined;
        acc[space.id] = {
            beforeEvent: beforeDuration !== null && beforeDuration !== void 0 ? beforeDuration : defaultWhenBuffersEnabled,
            bufferBeforeId: bufferBeforeId,
            afterEvent: afterDuration !== null && afterDuration !== void 0 ? afterDuration : defaultWhenBuffersEnabled,
            bufferAfterId: bufferAfterId,
        };
        return acc;
    }, {});
    return hasBuffers ? result : undefined;
};
